import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Home,
  Info,
  Users,
  Gift,
  Shield,
  Lock,
  Cookie,
  HelpCircle,
} from 'lucide-react';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const footerLinks = [
    { to: '/', label: 'Home', icon: <Home className="w-5 h-5" /> },
    {
      to: '/contactus',
      label: 'Contact Us',
      icon: <Users className="w-5 h-5" />,
    },
    {
      to: '/affiliate',
      label: 'Become an Affiliate',
      icon: <Gift className="w-5 h-5" />,
    },
    {
      to: '/signup?subscriptionType=1',
      label: 'Try It for Free',
      icon: <Info className="w-5 h-5" />,
    },
    {
      to: '/pricing/annually',
      label: 'Subscription Plans',
      icon: <Shield className="w-5 h-5" />,
    },
    {
      to: '/terms',
      label: 'Terms & Conditions',
      icon: <Lock className="w-5 h-5" />,
    },
    {
      to: '/privacy',
      label: 'Privacy Policy',
      icon: <Info className="w-5 h-5" />,
    },
    {
      to: '/cookies',
      label: 'Cookie Policy',
      icon: <Cookie className="w-5 h-5" />,
    },
    { to: '/faq', label: 'FAQ', icon: <HelpCircle className="w-5 h-5" /> },
  ];

  return (
    <footer className="bg-[#004aad] text-white py-6">
      <div className="mx-auto max-w-7xl px-4">
        <div className="flex flex-wrap justify-center gap-4 sm:gap-5 md:gap-6">
          {footerLinks.map((link, index) => (
            <button
              key={index}
              onClick={() => navigate(link.to)}
              className="flex flex-col items-center text-center transition duration-300 ease-in-out transform hover:scale-110 w-[calc(33.333%-16px)] sm:w-auto"
            >
              <span className="mb-1">{link.icon}</span>
              <span className="text-[14px] sm:text-[16px] md:text-[18px] font-medium hover:underline">
                {link.label}
              </span>
            </button>
          ))}
        </div>
        <div className="text-center mt-6 text-xs sm:text-sm">
          © {new Date().getFullYear()} My Code Dragon. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
